export class ListingFilter {
    public id:number|null;
    public listing_id:number;
    public name:string;

    constructor(data:ListingFilterData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.listing_id = -1;
            this.name = "";
        }
        else
        {
            this.id = data.id;
            this.listing_id = data.listing_id;
            this.name = data.name;
        }
    }
    public resetToDefaults():void {
        this.id = null;
        this.listing_id = -1;
        this.name = '';
    }
}

export type ListingFilterData = {
    id:number|null;
    listing_id:number;
    name:string;
}